import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { injectIntl } from 'react-intl';
import { secondaryOrange } from 'apollo-react-next/colors';
import { withStyles } from '@material-ui/core/styles';

import { AvailableFeaturesForm } from './constants';
import {
  fetchChannels,
  fetchIsHCOEnabled,
  fetchLimits,
  fetchMetrics,
  fetchTimePeriods,
  fetchUserData,
} from './actions';
import JourneyBuilderSendOptimizerComponent from './JourneyBuilderSendOptimizerComponent';

const styles = {
  mainWrapper: {
    flexGrow: 1,
    padding: 16,
  },
  paper: {
    maxWidth: 800,
    height: '100%',
    padding: 32,
    '& label': {
      marginBottom: 0,
    },
  },
  formWrapper: {
    height: '70%',
    overflowY: 'auto',
  },
  warningIcon: {
    color: secondaryOrange[500],
    marginRight: '5px',
  },
  warningMessage: {
    display: 'flex',
    alignItems: 'center',
    textTransform: 'none',
    fontWeight: 'normal',
    fontSize: 'small',
    marginBottom: '15px',
  },
};

const mapStateToProps = state => {
  const { journeyBuilderUIDataArea, journeyBuilderConfigurationArea } = state;
  const { steps } = journeyBuilderConfigurationArea;
  const { fuel2token } = journeyBuilderConfigurationArea.tokens;
  const { id } = journeyBuilderUIDataArea.userData.value.organization;
  const { hasValue } = journeyBuilderConfigurationArea.metaData;
  const isLoading =
    journeyBuilderUIDataArea.channels.isLoading ||
    journeyBuilderUIDataArea.timePeriods.isLoading ||
    journeyBuilderUIDataArea.limits.isLoading ||
    journeyBuilderUIDataArea.userData.isLoading ||
    journeyBuilderConfigurationArea.isLoading;

  const selector = formValueSelector(AvailableFeaturesForm);
  const activityType = selector(state, 'activityType');
  const isHCOEnabled = journeyBuilderUIDataArea.featureFlag.isHCOEnabled;

  return {
    steps,
    fuel2token,
    buID: id,
    activityType,
    isHCOEnabled,
    hasLinkedTopic: hasValue,
    isLoading,
  };
};

const mapDispatchToProps = {
  fetchTimePeriods,
  fetchChannels,
  fetchUserData,
  fetchLimits,
  fetchMetrics,
  fetchIsHCOEnabled,
};

export const enhance = lifecycle({
  componentDidMount() {
    const { fetchTimePeriods, fetchMetrics } = this.props;
    fetchTimePeriods();
    fetchMetrics();
  },
  componentDidUpdate(prev) {
    const {
      fetchChannels,
      fetchLimits,
      fetchUserData,
      fuel2token,
      buID,
      fetchIsHCOEnabled,
    } = this.props;
    if (prev.buID !== buID) {
      fetchChannels(buID);
      fetchLimits(buID);
      fetchIsHCOEnabled(buID);
    }

    if (prev.fuel2token !== fuel2token) {
      const rootMID = window.App.rootBusinessUnitMID;
      fetchUserData(rootMID, fuel2token);
    }
  },
})(JourneyBuilderSendOptimizerComponent);

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withStyles(styles, { name: 'JourneyBuilderComponent' })
)(enhance);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/JourneyBuilderSendOptimizerContainer.js